import { Vector2, Vector3 } from '@adaptiva/core/space';
import { BaseWidgetComponent, provideBaseWidget } from '@adaptiva/core/widgets';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, forwardRef, input, InputSignal, model, ModelSignal, Signal, viewChild } from '@angular/core';
import { IGridStyle, viewboxDotGrid, ViewboxGridDirective } from './viewbox-grid';
import { ViewboxDirective } from './viewbox.directive';
import { IViewbox } from './viewbox.interface';

@Component({
	selector: '[ada-viewbox]',
	templateUrl: './viewbox.component.html',
	styleUrls: ['./viewbox.component.scss'],
	imports: [
		CommonModule,
		ViewboxDirective,
		ViewboxGridDirective,
	],
	providers: [
		provideBaseWidget(() => ViewboxComponent),
		{
			provide: IViewbox,
			useExisting: forwardRef(() => ViewboxComponent)
		}
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewboxComponent extends BaseWidgetComponent implements IViewbox {

	public readonly x: ModelSignal<float> = model(0);

	public readonly y: ModelSignal<float> = model(0);

	public readonly z: ModelSignal<float> = model(1.0);

	public readonly canPan: ModelSignal<boolean> = model(true);

	public readonly minZoom: InputSignal<float> = input(0.25);

	public readonly zoomFactor: InputSignal<float> = input(0.001);

	public readonly hasBackgroundGrid: InputSignal<boolean> = input(true);

	protected readonly directive: Signal<IViewbox> = viewChild.required(IViewbox);

	public readonly backgroundGridStyles: InputSignal<IGridStyle[]> = input(
		viewboxDotGrid({
			backgroundColor: 'background',
			dotRadius: .5,
			gridColor: 'foreground'
		})
	);

	public readonly camera: Signal<Vector3> = computed(() => {
		return new Vector3(this.x(), this.y(), this.z());
	});

	public getCenter(): Vector2 {
		return this.directive().getCenter();
	}

	public repaint(x: float, y: float, z: float): void {
		this.directive().repaint(x, y, z);
	}

	public applyTransition(): void {
		this.directive().applyTransition();
	}

}
